<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <div class="topo">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header-light page-title="MODALIDADES" fa-icon="folder-open"></lib-page-header-light>
        </div>
        <div class="col-md-6">
          <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        </div>
      </div>
    </div>
    <hr class="mt-1" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" class="text-center">ID</th>
                <th scope="col" class="text-center">TCE</th>
                <th scope="col">Nome</th>
                <th scope="col">Limites</th>
                <th scope="col">Exigências</th>
                <th scope="col" style="width: 90px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <th scope="row" class="text-center">{{item.id}}</th>
                <td class="text-center">{{item.codigo}}</td>
                <td>{{item.nome}}</td>
                <td>
                  <span class="d-block" *ngIf="+item.valor_limite > 0">Valor: {{item.valor_limite |
                    number:'1.2-2'}}</span>
                  <span class="d-block" *ngIf="+item.prazo_limite > 0">Dias: {{item.prazo_limite |
                    number:'1.0-0'}}</span>
                </td>
                <td>
                  <span *ngIf="item.exigir_licitacao" class="badge badge-primary">Licitação</span>
                  <span *ngIf="item.exigir_contrato" class="badge badge-success">Contrato</span>
                  <span *ngIf="item.exigir_convenio" class="badge badge-secondary">Convênio</span>
                </td>
                <td class="text-right" style="min-width: 100px;">
                  <button [routerLink]="['/modalidades', item.id, 'editar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir()" class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>